import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Header() {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const currentLang = i18n.language.toUpperCase().substring(0, 2);

  const menuItems = [
    { key: 'inicio', label: t('nav.inicio') },
    { key: 'aurion', label: t('nav.aurion') },
    { key: 'sectores', label: t('nav.sectores') },
    { key: 'metodo', label: t('nav.metodo') },
    { key: 'porQueAurion', label: t('nav.porQueAurion') },
    { key: 'noticias', label: t('nav.noticias') },
    { key: 'estudioGratuito', label: t('nav.estudioGratuito') },
    { key: 'faqs', label: t('nav.faqs') },
    { key: 'contacto', label: t('nav.contacto') }
  ];

  const languages = [
    { code: 'es', label: 'ES' },
    { code: 'ca', label: 'CA' },
    { code: 'eu', label: 'EU' },
    { code: 'en', label: 'EN' }
  ];

  const handleNavClick = (key: string) => {
    if (key === 'inicio') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const getHref = (key: string) => {
    const hrefMap: Record<string, string> = {
      inicio: '#',
      aurion: '#aurion',
      sectores: '#sectores',
      metodo: '#metodo',
      porQueAurion: '#por-que',
      noticias: '#noticias',
      estudioGratuito: '#oferta',
      faqs: '#faqs',
      contacto: '#oferta'
    };
    return hrefMap[key] || '#';
  };

  const changeLanguage = (langCode: string) => {
    i18n.changeLanguage(langCode);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0 -ml-12">
            <h1>
              <img 
                src="https://static.readdy.ai/image/d2dacb92e0221beafae8fac9226481ac/5086d91de1caebf58e4a66cae0029c78.png" 
                alt="AURION Energy Tech" 
                title="AURION"
                className="h-52 w-auto"
              />
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8">
            {menuItems.map((item) => (
              <a
                key={item.key}
                href={getHref(item.key)}
                onClick={(e) => {
                  if (item.key === 'inicio') {
                    e.preventDefault();
                    handleNavClick(item.key);
                  }
                }}
                className="text-gray-700 hover:text-teal-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Language Selector & Mobile Menu */}
          <div className="flex items-center space-x-4">
            {/* Language Selector */}
            <div className="flex items-center space-x-2 border border-gray-300 rounded-lg px-3 py-1.5">
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => changeLanguage(lang.code)}
                  className={`text-sm font-medium cursor-pointer transition-colors duration-200 ${
                    currentLang === lang.label ? 'text-teal-600' : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  {lang.label}
                </button>
              ))}
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden w-6 h-6 flex items-center justify-center cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-3">
              {menuItems.map((item) => (
                <a
                  key={item.key}
                  href={getHref(item.key)}
                  onClick={(e) => {
                    if (item.key === 'inicio') {
                      e.preventDefault();
                      handleNavClick(item.key);
                    }
                    setIsMenuOpen(false);
                  }}
                  className="text-gray-700 hover:text-teal-600 transition-colors duration-200 cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
